import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import WordGameEasyMode from '../components/WordGame/WordGameEasyMode';
import WordGameMediumMode from '../components/WordGame/WordGameMediumMode';
import WordGameHardMode from '../components/WordGame/WordGameHardMode';
import DailyGamePlayGate from '../components/DailyGamePlayGate';

const WordGamePlay = () => {
    const location = useLocation();
    const [level, setLevel] = useState(null);
    useEffect(() => {
        setLevel(location?.state?.level);
    }, [location?.state]);
    let game = null;
    switch (String(level)) {
            case "1":
                game = <WordGameEasyMode />;
                break;

            case "2":
                game = <WordGameMediumMode />;
                break;
            case "3":
                game = <WordGameHardMode />;
                break;
            default: return null
    }

    return (
        <DailyGamePlayGate gameName="Word Game" levelId={level}>
            {game}
        </DailyGamePlayGate>
    );
}

export default WordGamePlay